import React from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';

function AuthLayout() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background:
          'radial-gradient(circle at top, rgba(99,102,241,0.15), transparent 55%), radial-gradient(circle at 20% 20%, rgba(236,72,153,0.15), transparent 45%)',
        px: 2,
      }}
    >
      <Outlet />
    </Box>
  );
}

export default AuthLayout;


